import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const AdvancedAssessmentChart = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const rawEmail = queryParams.get('email');
  const email = rawEmail ? rawEmail.trim() : null;
  const [error, setError] = useState('');

  // Debug logging
  console.log('DEBUG AdvancedAssessmentChart - Raw URL search:', location.search);
  console.log('DEBUG AdvancedAssessmentChart - Raw email from params:', rawEmail);
  console.log('DEBUG AdvancedAssessmentChart - Processed email:', email);

  useEffect(() => {
    const fetchData = async () => {
      if (!email) {
        setError('No email provided');
        return;
      }

      try {
        const url = `https://e6w2t1d2f1.execute-api.us-east-1.amazonaws.com/dev/survey/${email}?advance=true`;
        console.log('DEBUG AdvancedAssessmentChart - Final API URL:', url);
        const response = await axios.get(url);   
        console.log(response.data);     
      } catch (error:any) {
        console.log('error',error.response.data.message);
        setError(error.response.data.message)
      }
    }

    fetchData();
  }, [email])

  return (
    <div className="min-h-screen w-full flex items-center justify-center p-2">
        <div className="flex flex-col items-center justify-center w-full max-w-2xl mx-auto rounded-lg p-6">
            <div className="text-center flex flex-col mb-3 gap-3">
                <img className="mx-auto h-14 w-auto" src="newLogo.png" alt="Shvesa Logo" />
                <p className="text-2xl">Advanced Assessment Report</p>
                <p className="text-xl">{email}</p>
                {error && <p className="text-xl">{email}</p>}
            </div>
        </div>
    </div>
  )
}

export default AdvancedAssessmentChart